
/* Image gallery (lightbox) functionality */ const $a5a1440ae8e8f337$var$lightboxOverlay = document.querySelector('.lightbox-overlay');
const $a5a1440ae8e8f337$var$lightboxImage = document.querySelector('.lightbox-overlay img');
const $a5a1440ae8e8f337$var$lightboxCaption = document.querySelector('.lightbox-overlay .caption');
const $a5a1440ae8e8f337$var$lightboxCloseBtn = document.querySelector('.lightbox-content .btn-close');
/* Open lightbox */ const $a5a1440ae8e8f337$var$galleryImages = [
    ...document.querySelectorAll('.gallery-item img')
];
const $a5a1440ae8e8f337$var$contentDiv = document.querySelector('.content');
const $a5a1440ae8e8f337$var$lightboxNext = document.querySelector('.lightbox-content .btn-next');
const $a5a1440ae8e8f337$var$lightboxPrev = document.querySelector('.lightbox-content .btn-prev');
function $a5a1440ae8e8f337$var$showImageInLightbox(imageNode) {
    const captionElement = imageNode.parentElement.querySelector('figcaption');
    const captionText = captionElement ? captionElement.textContent : '';
    const imgIndex = $a5a1440ae8e8f337$var$galleryImages.indexOf(imageNode);
    // show/hide next/prev buttons
    $a5a1440ae8e8f337$var$lightboxPrev.style.visibility = imgIndex === 0 ? 'hidden' : 'visible';
    $a5a1440ae8e8f337$var$lightboxNext.style.visibility = imgIndex === $a5a1440ae8e8f337$var$galleryImages.length - 1 ? 'hidden' : 'visible';
    $a5a1440ae8e8f337$var$lightboxImage.setAttribute('src', imageNode.src);
    $a5a1440ae8e8f337$var$lightboxCaption.textContent = captionText;
}
$a5a1440ae8e8f337$var$contentDiv.addEventListener('click', function(e) {
    if (e.target.matches('.gallery-item img')) {
        $a5a1440ae8e8f337$var$lightboxOverlay.style.display = 'flex';
        $a5a1440ae8e8f337$var$showImageInLightbox(e.target);
    }
});
/* Cycle through lightbox images */ function $a5a1440ae8e8f337$var$showNextImageInLightbox() {
    const imgIndex = $a5a1440ae8e8f337$var$galleryImages.findIndex((img)=>$a5a1440ae8e8f337$var$lightboxImage.getAttribute('src').includes(img.getAttribute('src')));
    if (imgIndex === -1) return;
    if (imgIndex < $a5a1440ae8e8f337$var$galleryImages.length - 1) $a5a1440ae8e8f337$var$showImageInLightbox($a5a1440ae8e8f337$var$galleryImages[imgIndex + 1]);
}
function $a5a1440ae8e8f337$var$showPrevImageInLightbox() {
    const imgIndex = $a5a1440ae8e8f337$var$galleryImages.findIndex((img)=>$a5a1440ae8e8f337$var$lightboxImage.getAttribute('src').includes(img.getAttribute('src')));
    if (imgIndex === -1) return;
    if (imgIndex > 0) $a5a1440ae8e8f337$var$showImageInLightbox($a5a1440ae8e8f337$var$galleryImages[imgIndex - 1]);
}
$a5a1440ae8e8f337$var$lightboxNext.addEventListener('click', $a5a1440ae8e8f337$var$showNextImageInLightbox);
$a5a1440ae8e8f337$var$lightboxPrev.addEventListener('click', $a5a1440ae8e8f337$var$showPrevImageInLightbox);
/* Close lightbox */ function $a5a1440ae8e8f337$var$closeLightbox(e) {
    $a5a1440ae8e8f337$var$lightboxOverlay.style.display = 'none';
    $a5a1440ae8e8f337$var$lightboxImage.removeAttribute('src');
    $a5a1440ae8e8f337$var$lightboxCaption.textContent = '';
}
$a5a1440ae8e8f337$var$lightboxCloseBtn.addEventListener('click', $a5a1440ae8e8f337$var$closeLightbox);
// keyboard navigation
document.addEventListener('keydown', function(e) {
    const isLightboxVisible = $a5a1440ae8e8f337$var$lightboxOverlay.style.display !== 'none';
    if (!isLightboxVisible) return;
    if (e.code === 'Escape') $a5a1440ae8e8f337$var$closeLightbox();
    else if (e.code === 'ArrowRight') $a5a1440ae8e8f337$var$showNextImageInLightbox();
    else if (e.code === 'ArrowLeft') $a5a1440ae8e8f337$var$showPrevImageInLightbox();
});


//# sourceMappingURL=vali-city.c1e03d49.js.map
